import axios from 'axios';
import Feature from '../models/Feature';
import Plan from '../models/Plan';
import request from '../shared/http';
import appConfig from '../shared/js/app-config';
import API_CONFIG from '../config/api.config';

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  HALTED: 'halted',
  PAUSED: 'paused',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

class SubscriptionService {
  parseSubscription(item) {
    return {
      id: item.id,
      subscriptionId: item.subscription_id,
    };
  }

  parsePlan(item) {
    return {
      planName: item.plan_name,
      description: item.description,
      amount: item.amount,
      planId: item.plan_id,
      currency: item.currency,
      duration: item.duration,
      applyCount: item.apply_count,
      features: item.features.map((model) => new Feature({
        featureId: model.feature_id,
        featureName: model.feature_name,
        limit: model.limit,
        units: model.units,
      })),
    };
  }

  async createSubscription({ planId }) {
    const { data } = await request.post(
      '/subscriptions',
      {
        plan_id: planId,
        platform: 'desktop',
        pay_by: 'razorpay',
        service_id: appConfig.getServiceId(),
      },
    );
    window.open(data, '_blank');
    // return new Subscription({ ...this.parseSubscription(data) });
  }

  async cancelSubscription(id) {
    const url = '/subscriptions/cancel';
    const { data } = await request.put(url, { subscription_id: id });
    return data;
  }

  async getAllPlans() {
    const domain = API_CONFIG.BASE_URL;
      const url = `${domain}/plans`;
    const res = await axios.get(url, {
        params:{
            type: 'whatsapp',
        }
    });
    const { data } = res.data;
    if (data) {
      const response = data.map((model) => new Plan({ ...this.parsePlan(model) }));
      return response;
    }
    return [];
  }

  async getRazorpaySubscriptionKeyId() {
    const { data } = await request.get('razorpay_subscription_key_id');
    return data;
  }

  async getPlanAssociationCount(id) {
    const url = `/plan/count/${id}`;
    const { data } = await request.get(url);
    return data;
  }

}

export default new SubscriptionService();
